/**
 * Stable CSS class names for E2E — Add/Edit group dialog.
 */
export const AGD = {
    dialog: 'add-group-dialog',
    title: 'add-group-dialog__title',
    content: 'add-group-dialog__content',
    actions: 'add-group-dialog__actions',

    groupNameInput: 'add-group-dialog-input__group-name',
    activeRow: 'add-group-dialog__active-row',
    activeLabel: 'add-group-dialog__active-label',
    activeSwitch: 'add-group-dialog-input__active-switch',

    submitButton: 'add-group-dialog-input--button-submit',
    cancelButton: 'add-group-dialog-input--button-cancel',
} as const;

export const agdCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

